import { render, staticRenderFns } from "./ManageArticle.vue?vue&type=template&id=5d111c8f&"
import script from "./ManageArticle.vue?vue&type=script&lang=js&"
export * from "./ManageArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports